/**
 * Pronto Posto – Maildaten · Spanisch (es-ES) · KS04
 *
 * KS04 Flug – Lady Luna / Amadeo Grande. Postfach: a.grande@pronto-posto.com
 *
 * Aufteilung nach language/episode: geteilte Inhalte einer Sprache leben in ./_shared.js.
 * Sprachen sind strikt getrennt – Mails dieser Datei adressieren ausschliesslich Postfaecher
 * dieser Sprache. IDs sind global eindeutig (siehe ID-Reservierungen in den Blockkommentaren).
 */
/* eslint-disable */

export function getEmails() {
    return [
        // luna–largo mails (ks04 flug) — ES (Amadeo Grande account: a.grande@pronto-posto.com)
        {
            id: 61,
            from: { email: 'lady.luna@espacioanimatv.es', name: 'Lady Luna', avatar: require('@src/assets/images/portrait/luna.jpg').default },
            to: [{ name: 'Amadeo Grande', email: 'a.grande@pronto-posto.com' }],
            subject: 'Re: Solicitud: sesión especial en su programa',
            cc: [], bcc: [],
            message: "Amadeo,<p>este asunto parece importarle mucho. Para asegurarnos del todo de que las cartas no decidan de repente otra cosa — o de que a mí no se me escape algo durante el programa —, los honorarios tendrían que ser de 6.000 €.<p>Un saludo,<p>Lady Luna",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Mar. 28 2024 15:08:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 60,
                    from: { email: 'a.grande@pronto-posto.com', name: 'Amadeo Grande', avatar: require('@src/assets/images/portrait/lange.jpg').default },
                    to: [{ name: 'Lady Luna', email: 'lady.luna@espacioanimatv.es' }],
                    subject: 'Solicitud: sesión especial en su programa',
                    cc: [], bcc: [],
                    message: "Hola Lady Luna,<p>si no la juzgo mal, somos prácticamente colegas de profesión, y nunca le hace ascos a un pequeño ingreso extra.<p>Tengo un encargo especial: mi suegra supersticiosa, Krystyna Zielinski, seguramente la llamará el 31/03 con motivo del décimo aniversario de su cadena. Es una de sus espectadoras habituales. Hay que convencerla como sea de que ceda su villa de campo a su hija (y a mí). Procure que, durante el programa, las cartas recomienden claramente esa donación — diga lo que diga en realidad.<p>Ofrezco 3.000 € de honorarios. Doy por sentada su discreción.<p><p>Un saludo,<p>Amadeo Grande",
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Thu. Mar. 28 2024 14:02:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 63,
            from: { email: 'lady.luna@espacioanimatv.es', name: 'Lady Luna', avatar: require('@src/assets/images/portrait/luna.jpg').default },
            to: [{ name: 'Amadeo Grande', email: 'a.grande@pronto-posto.com' }],
            subject: 'Re: Re: Re: Solicitud: sesión especial en su programa',
            cc: [], bcc: [],
            message: "El dinero ha llegado. Orientaré las cartas como me ha pedido — su suegra recibirá la señal perfecta para la donación.<p>Le haré llegar un clip de lo mejor en cuanto el programa esté grabado.<p>Por más buenos negocios,<p>Lady Luna",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Mar. 28 2024 21:58:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 62,
                    from: { email: 'a.grande@pronto-posto.com', name: 'Amadeo Grande', avatar: require('@src/assets/images/portrait/lange.jpg').default },
                    to: [{ name: 'Lady Luna', email: 'lady.luna@espacioanimatv.es' }],
                    subject: 'Re: Re: Solicitud: sesión especial en su programa',
                    cc: [], bcc: [],
                    message: "¿¿¿¿Esto es un chantaje???? Qué desfachatez. Pero bueno, hoy estoy de buen humor. 5.000 € y ni un céntimo más. Preferiblemente en cripto. Hablemos luego por teléfono. +34 XXXXX152.",
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Thu. Mar. 28 2024 18:22:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 64,
            from: { email: 'lady.luna@espacioanimatv.es', name: 'Lady Luna', avatar: require('@src/assets/images/portrait/luna.jpg').default },
            to: [{ name: 'Amadeo Grande', email: 'a.grande@pronto-posto.com' }],
            subject: 'Las cartas han hablado',
            cc: [], bcc: [],
            message: "Amadeo,<p>Las cartas han hablado. Adjunto el clip relativo a nuestro pequeño acuerdo.<p>Por más buenos negocios,<p>Lady Luna<p>PD: si necesita ayuda más a menudo: en EspacioÁnimaTV tenemos una solución para cada inquietud, siempre que el universo (y su cuenta bancaria) colaboren.",
            attachments: [
                {
                    fileName: 'clip_espacioanima_tv.mp4',
                    thumbnail: require('@src/assets/images/icons/jpg.png').default,
                    url: 'https://storage.googleapis.com/cc-pronto-posto/ks04_soulspace_es-es.mp4',
                    size: '10mb',
                },
            ],
            isStarred: true,
            labels: ['personal'],
            time: 'Sun. Mar. 31 2024 15:45:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 65,
                    from: { email: 'a.grande@pronto-posto.com', name: 'Amadeo Grande', avatar: require('@src/assets/images/portrait/lange.jpg').default },
                    to: [{ name: 'Lady Luna', email: 'lady.luna@espacioanimatv.es' }],
                    subject: 'Re: Las cartas han hablado',
                    cc: [], bcc: [],
                    message: "Acabo de ver el clip de lo mejor, tío menuda panda de chiflados jajaja, pensaba que eso solo existía en la burbuja de las cripto. Pero da igual, Krystyna picó el anzuelo. <p>Gracias por el apoyo « divino ».<p>¡Ya le escribiré si hace falta!",
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Sun. Mar. 31 2024 18:40:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                },
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 66,
            from: { email: 'renderrambo@pronto-posto.com', name: 'Render Rambo', avatar: require('@src/assets/images/portrait/rambo.jpg').default },
            to: [{ name: 'Amadeo Grande', email: 'a.grande@pronto-posto.com' }],
            subject: 'Nuevo Reel',
            cc: [], bcc: [],
            message: "Ey Amadeo,<p>He terminado de montar tu reel, ¡ha quedado superfresco! A los finance bros les va a encantar, mándame el pago directamente en BillionCoins, me has convencido del todo :P<p>Dime sobre todo si el vídeo te gusta así, o si tengo que cambiar algo más.<p>El vídeo va adjunto<p>P.D: ¡luego invítame a dar una vuelta en tu nuevo juguete! ;)",
            attachments: [
                {
                    fileName: 'CryptoReel_Max.mp4',
                    thumbnail: require('@src/assets/images/icons/mp4.png').default,
                    url: 'https://storage.googleapis.com/cc-pronto-posto/ks04_cryptoreel_maxx_es-es.mp4',
                    size: '10mb',
                },
            ],
            isStarred: false,
            labels: ['work'],
            time: 'Sun. Feb. 25 2024 16:45:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },
    ]
}

export function getSpam() {
    return [
        //ks04 flug — ES (Amadeo Grande account: a.grande@pronto-posto.com)
        {
            id: 150,
            from: { email: 'omar@takatookaland-royal.org', name: 'Príncipe Omar', avatar: require('@src/assets/images/portrait/prince.jpg').default },
            to: [{ name: 'Amadeo Grande', email: 'a.grande@pronto-posto.com' }],
            subject: '¡El príncipe Omar necesita tu ayuda!',
            cc: [], bcc: [],
            message: "<p>Querido amigo,</p><p>Soy el príncipe Omar del lejano reino de Takatukalandia. Por desgracia, estoy atrapado con millones de monedas de oro que solo tú puedes salvar.</p><p>Ayúdame a transferir mi fortuna a tu cuenta y recibirás de por vida invitaciones a las fiestas del té reales.</p><p><b>¡Date prisa, mis reservas de té son limitadas!</b></p><br><p>Tu desesperado príncipe Omar</p>",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Wed. Jul. 10 2024 18:24:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 151,
            from: { email: 'info@wellbeingwonders.com', name: 'Equipo Bienestar Milagroso', avatar: require('@src/assets/images/portrait/vitamins.jpg').default },
            to: [{ name: 'Amadeo Grande', email: 'a.grande@pronto-posto.com' }],
            subject: '¡Los médicos están perplejos! ¡Las verduras sobran!',
            cc: [], bcc: [],
            message: "<p>Querido amigo preocupado por tu salud,</p><p>¡Olvídate del brócoli, las espinacas y las zanahorias! Nuestras revolucionarias gominolas contienen todas las vitaminas que podrías llegar a necesitar.</p><p>¡Pide hoy mismo y te enviamos además un paquete de ensalada de chocolate gratis!</p><br><p>Cuídate,<br>Tu equipo Bienestar Milagroso</p>",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Jul. 18 2024 20:11:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 152,
            from: { email: 'service@cosmic-realestate.com', name: 'Equipo Inmobiliario Cósmico', avatar: require('@src/assets/images/portrait/moon.jpg').default },
            to: [{ name: 'Amadeo Grande', email: 'a.grande@pronto-posto.com' }],
            subject: '¡Tu propia parcela en la Luna te espera!',
            cc: [], bcc: [],
            message: "<p>Estimado futuro propietario lunar,</p><p>Aprovecha ahora tu oportunidad única de convertirte en propietario oficial de una parcela en la Luna.</p><p>Reserva hoy mismo una parcela exclusiva con vistas inmejorables a la Tierra. ¡Disponibilidad limitada!</p><br><p>Tu equipo Inmobiliario Cósmico</p>",
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Tue. Jul. 23 2024 10:50:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 153,
            from: { email: 'jobs@aqua-careers.org', name: 'Equipo de Carreras Acuáticas', avatar: require('@src/assets/images/portrait/dolphin.jpg').default },
            to: [{ name: 'Amadeo Grande', email: 'a.grande@pronto-posto.com' }],
            subject: 'Buscamos traductores de delfines: ¡oportunidad lucrativa!',
            cc: [], bcc: [],
            message: "<p>Estimado amante del mar,</p><p>¿Estás listo para una carrera extraordinaria?</p><p>Buscamos con urgencia personas que entiendan el idioma de los delfines o quieran aprenderlo. No se necesita experiencia previa, remuneración generosa garantizada.</p><p>¡Solicítalo hoy mismo!</p><br><p>Tu equipo de Carreras Acuáticas</p>",
            attachments: [],
            isStarred: false,
            labels: ['company'],
            time: 'Mon. Jul. 29 2024 04:01:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        }
    ]
}
